<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <button class="btn btn-primary mb-2" @click="addNewItem">ساخت راهنما جدید</button>
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>فارسی</th>
                    <th>انگلیسی</th>
                    <th>نمایش از</th>
                    <th>نمایش تا</th>
                    <th>وضعیت</th>
                    <th>قوانین نمایش</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="banner in banners" :key="banner._id">
                    <td>{{ banner.fa }}</td>
                    <td>{{ banner.en }}</td>
                    <td>
                      {{
                        banner.activeFrom
                          ? `${new Date(banner.activeFrom).toLocaleDateString('fa-IR')} - ${new Date(
                              banner.activeFrom,
                            ).toLocaleTimeString('fa-IR')}`
                          : '-'
                      }}
                    </td>
                    <td>
                      {{
                        banner.activeTo
                          ? `${new Date(banner.activeTo).toLocaleDateString('fa-IR')} - ${new Date(
                              banner.activeTo,
                            ).toLocaleTimeString('fa-IR')}`
                          : '-'
                      }}
                    </td>
                    <td>{{ banner.isActive ? 'فعال' : 'غیر فعال' }}</td>
                    <td>
                      {{ banner.isShowRulesActive ? getRulesString(banner.showRules) : 'نمایش به همه' }}
                    </td>
                    <td>
                      <button class="btn btn-secondary" @click="editItem(banner)">ویرایش</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="ADDEDITMODAL" class="modal fade" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">راهنما</h4>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">بستن</span>
            </button>
          </div>
          <form class="form-horizontal" v-on:submit.prevent>
            <div class="modal-body">
              <div class="row d-flex align-items-center mb-5">
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" v-model="modal.fa" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>راهنما فارسی</label>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="order" type="text" v-model="modal.en" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>راهنما انگلیسی</label>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group row d-flex align-items-center mb-5">
                    <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">شروع نمایش از</label>
                    <date-picker
                      name="startDate"
                      type="datetime"
                      inputFormat="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DDTHH:mm:SSZ"
                      locale="fa,en"
                      altFormat="MM-DD-YYYY HH:mm"
                      v-model="modal.activeFrom"
                    ></date-picker>
                    <div class="col-lg-6"></div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group row d-flex align-items-center mb-5">
                    <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نمایش تا</label>
                    <date-picker
                      name="startDate"
                      type="datetime"
                      inputFormat="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DDTHH:mm:SSZ"
                      locale="fa,en"
                      altFormat="MM-DD-YYYY HH:mm"
                      v-model="modal.activeTo"
                    ></date-picker>
                    <div class="col-lg-6"></div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <label>فعال باشد؟</label>
                      <input class="" name="" type="checkbox" v-model="modal.isActive" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <label>نمایش در دونفره</label>
                      <input class="" name="" type="checkbox" v-model="modal.showInMulti" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <label>نمایش در مستر</label>
                      <input class="" name="" type="checkbox" v-model="modal.showInMaster" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <label>نمایش در لیگ</label>
                      <input class="" name="" type="checkbox" v-model="modal.showInLeague" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <label>نمایش در خانه</label>
                      <input class="" name="" type="checkbox" v-model="modal.showInHome" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت قوانین نمایش</label>
                  <div class="col-lg-6">
                    <select name="isShowRulesActive" class="form-control" id v-model="modal.isShowRulesActive">
                      <option :value="true">فعال</option>
                      <option :value="false">غیر فعال</option>
                    </select>
                  </div>
                </div>

                <div v-if="modal.isShowRulesActive" class="col-lg-12">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"> قوانین نمایش</label>
                  <div class="col-lg-6">
                    <select name="showRules" class="form-control" id v-model="modal.showRules" multiple>
                      <option disabled value="">انتخاب کنید</option>
                      <option v-for="rule in rules" :key="rule._id" :value="rule._id">{{ rule.title }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button v-if="modal._id" @click="deleteBanner" type="button" class="btn btn-danger ml-4">
                حذف
              </button>
              <button type="submit" class="btn btn-primary ml-auto" @click="changeItem">
                ذخیره
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import HintService from '../../../../services/hint';
import moment from 'moment';
import PermissionService from '../../../../services/UsersRulePermissions';

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  name: 'league',
  data() {
    return {
      banners: [],
      rules: [],
      modal: {
        isShowRulesActive: false,
      },
      file: null,
    };
  },
  created() {
    this.getBanners({});
    this.getRules();
  },
  methods: {
    async getBanners(conditions) {
      try {
        const data = await new HintService().allHints(conditions);
        this.banners = data;
      } catch (err) {
        console.log(err);
      }
    },

    addNewItem() {
      this.modal = {};
      this.file = null;
      window.$('#ADDEDITMODAL').modal('show');
    },
    editItem(item) {
      this.modal = { ...item };
      this.file = null;
      window.$('#ADDEDITMODAL').modal('show');
    },
    async getRules() {
      try {
        const resData = await PermissionService.getRules({});
        this.rules = resData;
      } catch (err) {
        console.log(err);
      }
    },
    getRulesString(rules) {
      let string = '';
      for (let i = 0; i < rules.length; i++) {
        const rule = rules[i];
        string += `${rule.title}`;
        if (i != rules.length - 1) {
          string += ' | ';
        }
      }
      return string;
    },
    async changeItem() {
      try {
        const data = {
          en: this.modal.en,
          fa: this.modal.fa,
          isActive: this.modal.isActive ?? false,
          showInMulti: this.modal.showInMulti ?? false,
          showInMaster: this.modal.showInMaster ?? false,
          showInLeague: this.modal.showInLeague ?? false,
          showInHome: this.modal.showInHome ?? false,
          isShowRulesActive: this.modal.isShowRulesActive,
          showRules: this.modal.showRules,
        };

        if (this.modal.activeFrom) {
          data.activeFrom = moment(this.modal.activeFrom, 'YYYY-MM-DDTHH:mm:SSZ').toISOString();
        }

        if (this.modal.activeTo) {
          data.activeTo = moment(this.modal.activeTo, 'YYYY-MM-DDTHH:mm:SSZ').toISOString();
        }

        if (this.modal._id) {
          data.id = this.modal._id;

          await new HintService().updateHint(data);
          // edit
          window.notif({ isError: false, mssg: `راهنما بروزرسانی شد` });
          window.$('#ADDEDITMODAL').modal('hide');
          this.getBanners({});
        } else {
          await new HintService().createHint(data);
          window.notif({ isError: false, mssg: `راهنما ایجاد شد` });
          window.$('#ADDEDITMODAL').modal('hide');
          this.getBanners({});
        }
      } catch (error) {
        console.error(error);
        window.notif({ isError: true, mssg: `مشکلی پیش آمده بعدا تلاش کنید` });
      }
    },

    async deleteBanner() {
      try {
        await new HintService().deleteHint({ id: this.modal._id });
        window.notif({ isError: false, mssg: `راهنما حذف شد` });
        window.$('#ADDEDITMODAL').modal('hide');
        this.getBanners({});
      } catch (error) {
        window.notif({ isError: true, mssg: `مشکلی پیش آمده بعدا تلاش کنید` });
      }
    },
  },
};
</script>
